module.exports = "/images/vendor/flag-icon-css/flags/4x3/bz.svg?64d617eaf3f2c6f3f0256985b4ede543";